<!--  ******************************************************  -->
<!--  ADD PRODUCTITEM DIALOG                                       -->
<!--    - Allows the user to insert a productItem                  -->
<!--  ******************************************************  -->

<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
  <span>
    {{'PRODUCTITEM.ADD' | translate}}</span>
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="mat-typography">


  <form class="example-form" #putProductItem="ngForm">

    <mat-tab-group>
      <mat-tab label="Dettagli" style="padding: 16px 0 !important;">

        <div fxFlex="100%" fxLayout="column">

          <!--  ************************************  -->
          <!--            CUSTOMER PRODUCTITEM             -->
          <!--  ************************************  -->
          <div fxLayout="row">
            <mat-form-field  class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.OWNER' | translate}}</mat-label>
              <input matInput required #customerTitle="ngModel" type="text" disabled name="customerTitle"
                     [(ngModel)]="data.customer.title">
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--              PRODUCTITEM NAME               -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.NAME' | translate}}</mat-label>
              <input matInput required #productItemName="ngModel" type="text" name="productItemName" [(ngModel)]="data.productItem.name" (input)="updateStationId()">
              <mat-error *ngIf="productItemName.invalid">
                {{'PRODUCTITEM.NAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--              PRODUCTITEM LABEL              -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.LABEL' | translate}}</mat-label>
              <input matInput required #productItemLabel="ngModel" type="text" name="productItemLabel"
                     [(ngModel)]="data.productItem.label">
              <mat-error *ngIf="productItemLabel.invalid">
                {{'PRODUCTITEM.LABEL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--          PRODUCTITEM PRODUCT_TYPE           -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField" style="line-height: 18px;">
              <mat-label>{{'PRODUCTITEM.PRODUCT_TYPE' | translate}}</mat-label>
              <mat-select class="mat-typography" name="parentCustomerId" [(ngModel)]="data.productItem.productType"
                          (ngModelChange)="productTypeChanged($event)" #productItemProductType="ngModel" required="">
                <mat-option *ngFor="let productItemType of gmService.productTypesEnum"
                            [value]="productItemType"><div fxFlex fxLayout="row" fxLayoutAlign="space-between center"><span class="mat-typography">{{productItemType.name}}</span><span style="color:gray">{{productItemType.monitored? ("PRODUCTITEM.MONITORED" | translate) : ("PRODUCTITEM.NOT_MONITORED"| translate) }}</span></div></mat-option>
                <mat-select-trigger *ngIf="!!data.productItem.productType"> {{data.productItem.productType.name}} </mat-select-trigger>
              </mat-select>
              <mat-error *ngIf="productItemProductType.invalid">
                {{'PRODUCTITEM.PRODUCT_TYPE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            PRODUCTITEM SERIAL #             -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.SERIAL_NUMBER' | translate}}</mat-label>
              <input matInput required #productItemSerialNumber="ngModel" type="text" name="productItemSerialNumber"
                     [(ngModel)]="data.productItem.serialNumber">
              <mat-error *ngIf="productItemSerialNumber.invalid">
                {{'PRODUCTITEM.SERIAL_NUMBER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--             PRODUCTITEM LATITUDE            -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.LATITUDE' | translate}}</mat-label>
              <input matInput [required]="!disableLocationLatLon" [disabled]="disableLocationLatLon"
                     #productItemLatitude="ngModel" type="number" name="productItemLatitude"
                     [(ngModel)]="data.productItem.latitude">
              <mat-error *ngIf="productItemLatitude.invalid">
                {{'PRODUCTITEM.LATITUDE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            PRODUCTITEM LONGITUDE            -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.LONGITUDE' | translate}}</mat-label>
              <input matInput [required]="!disableLocationLatLon" [disabled]="disableLocationLatLon"
                     #productItemLongitude="ngModel" type="number" name="productItemLongitude"
                     [(ngModel)]="data.productItem.longitude">
              <mat-error *ngIf="productItemLongitude.invalid">
                {{'PRODUCTITEM.LONGITUDE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--             PRODUCTITEM LOCATION            -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.LOCATION' | translate}}</mat-label>
              <input matInput required #productItemLocation="ngModel" type="text" name="productItemLocation"
                     [(ngModel)]="data.productItem.location">
              <mat-error *ngIf="productItemLocation.invalid">
                {{'PRODUCTITEM.LOCATION_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--              PRODUCTITEM NOTES              -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.NOTES' | translate}}</mat-label>
              <input matInput #productItemNotes="ngModel" type="text" name="productItemNotes"
                     [(ngModel)]="data.productItem.note">
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px" style="padding: 8px 0;">
            <!--  ************************************  -->
            <!--             PRODUCTITEM HAS-DAE             -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="productItemHasDae" [disabled]="!data.productItem.productType" [(ngModel)]="data.productItem.hasDae" fxFlex>{{'PRODUCTITEM.HAS_DAE' | translate}}</mat-slide-toggle>

            <!--  ************************************  -->
            <!--              PRODUCTITEM IS-E015            -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="productItemIsE015" [disabled]="!data.productItem.productType || !data.productItem.productType.monitored" [(ngModel)]="data.productItem.isE015" fxFlex>{{'PRODUCTITEM.IS_E015' | translate}}</mat-slide-toggle>
          </div>
          <div fxLayoutAlign="row baseline" fxLayoutGap="10px" style="padding: 8px 0;">
            <!--              ************************************-->
            <!--                     PRODUCTITEM ON CHIRPSTACK-->
            <!--              ************************************-->

            <mat-slide-toggle color="primary" name="useChirpstack"
                              [(ngModel)]="data.productItem.useChirpstack" fxFlex
                              [disabled]="!data.productItem.productType || !data.productItem.productType.monitored">
              {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_USE' | translate}}
            </mat-slide-toggle>

            <!--              ************************************-->
            <!--                          PRODUCTITEM EUI64-->
            <!--              ************************************-->
            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI' | translate}}</mat-label>
              <input matInput required #devEui="ngModel" type="text" name="devEui"
                     [disabled]="!data.productItem.useChirpstack"
                     [(ngModel)]="data.productItem.devEui"
                     [maxlength]="23"
                     [pattern]="EUIRegex">
              <mat-error *ngIf="devEui.invalid && data.productItem.devEui === ''" >
                {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="devEui.dirty && data.productItem.devEui !== '' && devEui.invalid">
                {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI_FIELD' | translate}} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div style="margin: 5px 0">
          <button style="height: 40px" type="button" mat-raised-button color="primary" (click)="fileInput.click()">{{'PRODUCTITEM.PICTURE' | translate}}</button>
          <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
          <span *ngIf="!!selectedFile" style="margin-left: 5px"><i>{{selectedFile.name}}</i></span>
          <button style="margin-left: 5px" *ngIf="!!selectedFile" type="button" mat-mini-fab color="primary"
                  (click)="resetImage()"><mat-icon>close</mat-icon></button>
        </div>
        <p style="padding: 8px 0; color:gray" class="noMargin" fxLayout="row">{{'PRODUCTITEM.CHARGERS_MSG' | translate}}</p>
      </mat-tab>

      <mat-tab label="DAE" [disabled]="!data.productItem.hasDae">
        <div fxFlex="100%" fxLayout="column">
          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center" >

            <!--  ************************************  -->
            <!--            DAE IS MONITORED            -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="daeIsMonitored" [disabled]="!data.productItem.productType || !data.productItem.productType.monitored" [(ngModel)]="data.productItem.daeAttributes.daeIsMonitored"
                              fxFlex>{{'PRODUCTITEM.DAE_IS_MONITORED' | translate}}</mat-slide-toggle>

            <!--  ************************************  -->
            <!--            DAE SERIAL NUMBER           -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.DAE_SERIAL_NUMBER' | translate}}</mat-label>
              <input matInput #productItemDaeSerialNumber="ngModel" type="text" name="productItemLocation"
                     [(ngModel)]="data.productItem.daeAttributes.daeSerialNumber">
              <mat-error *ngIf="productItemDaeSerialNumber.invalid">
                {{'PRODUCTITEM.DAE_SERIAL_NUMBER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">

            <!--  ************************************  -->
            <!--           DAE BATTERY EXPIRE           -->
            <!--  ************************************  -->
            <mat-form-field fxFlex>
              <mat-label>{{'PRODUCTITEM.DAE_BATTERY_EXPIRE_DATE' | translate }}</mat-label>
              <input matInput #batteryExp="ngModel" name="expireBatteryDate" [ngModel]="expireBatteryDate" [matDatepicker]="batDate"
                     (ngModelChange)="assignBattExpDate($event)">
              <mat-datepicker-toggle matSuffix [for]="batDate"></mat-datepicker-toggle>
              <mat-datepicker #batDate></mat-datepicker>
            </mat-form-field>


            <!--  ************************************  -->
            <!--           DAE BATTERY EXPIRE           -->
            <!--  ************************************  -->
            <mat-form-field fxFlex>
              <mat-label>{{'PRODUCTITEM.DAE_ELECTRODE_EXPIRE_DATE' | translate }}</mat-label>
              <input matInput #electrodeExp="ngModel" name="expireElectrodeDate" [ngModel]="expireElectrodeDate" [matDatepicker]="elDate"
                     (ngModelChange)="assignElectExpDate($event)">
              <mat-datepicker-toggle matSuffix [for]="elDate"></mat-datepicker-toggle>
              <mat-datepicker #elDate></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="E015" [disabled]="!data.productItem.isE015">
        <div fxFlex="100%" fxLayout="column">
          <div fxLayout="row" fxLayoutGap="10px">

            <!--  ************************************  -->
            <!--             E015 PROVIDER              -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_PROVIDER' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #productItemE015Provider="ngModel" type="text" name="productItemE015Provider"
                     [(ngModel)]="data.productItem.e015Attributes.providerName">
              <mat-error *ngIf="productItemE015Provider.invalid">
                {{'PRODUCTITEM.E015_PROVIDER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            E015 STATION ID             -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_STATION_ID' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015StationId="ngModel" type="text" name="e015StationId" [disabled]="true"
                     [(ngModel)]="data.productItem.e015Attributes.stationId">
              <mat-error *ngIf="e015StationId.invalid">
                {{'PRODUCTITEM.E015_STATION_ID_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <!--  ************************************  -->
          <!--         E015 LOCATION ADDRESS          -->
          <!--  ************************************  -->
          <div fxLayout="row">
            <mat-form-field  class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ADDRESS' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationAddress="ngModel" type="text" name="e015LocationAddress"
                     [(ngModel)]="data.productItem.e015Attributes.locationAddress">
              <mat-error *ngIf="e015LocationAddress.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ADDRESS_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">

            <!--  ************************************  -->
            <!--       E015 LOCATION ADDRESS TYPE       -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ADDRESS_TYPE' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationAddressType="ngModel" type="text" name="e015LocationAddressType"
                     [(ngModel)]="data.productItem.e015Attributes.locationAddressType">
              <mat-error *ngIf="e015LocationAddressType.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ADDRESS_TYPE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--         E015 LOCATION ZIP CODE         -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ZIP_CODE' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationZipCode="ngModel" type="text" name="e015LocationZipCode"
                     [(ngModel)]="data.productItem.e015Attributes.locationZipCode">
              <mat-error *ngIf="e015LocationZipCode.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ZIP_CODE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">

            <!--  ************************************  -->
            <!--          E015 LOCATION CITY           -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_CITY' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationCity="ngModel" type="text" name="e015LocationCity"
                     [(ngModel)]="data.productItem.e015Attributes.locationCity">
              <mat-error *ngIf="e015LocationCity.invalid">
                {{'PRODUCTITEM.E015_LOCATION_CITY_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--         E015 LOCATION PROVINCE         -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_PROVINCE' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationProvince="ngModel" type="text" name="e015LocationProvince"
                     [(ngModel)]="data.productItem.e015Attributes.locationProvince">
              <mat-error *ngIf="e015LocationProvince.invalid">
                {{'PRODUCTITEM.E015_LOCATION_PROVINCE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">

            <!--  ************************************  -->
            <!--           E015 LOCATION REGION         -->
            <!--  ************************************  -->
            <mat-form-field  fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_REGION' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015LocationRegion="ngModel" type="text" name="e015LocationRegion"
                     [(ngModel)]="data.productItem.e015Attributes.locationRegion">
              <mat-error *ngIf="e015LocationRegion.invalid">
                {{'PRODUCTITEM.E015_LOCATION_REGION_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--       E015 STATION ACCESSIBILITY       -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_STATION_ACCESSIBILITY' | translate}}</mat-label>
              <input matInput [required]="data.productItem.isE015" #e015StationAccessibility="ngModel" type="text" name="e015StationAccessibility"
                     [(ngModel)]="data.productItem.e015Attributes.stationAccessibility">
              <mat-error *ngIf="e015StationAccessibility.invalid">
                {{'PRODUCTITEM.E015_STATION_ACCESSIBILITY_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px" style="padding: 8px 0;">

            <!--  ************************************  -->
            <!--             PRODUCTITEM HAS-DAE             -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="e015AlwaysAvailable" [(ngModel)]="data.productItem.e015Attributes.isAlwaysAvailable" fxFlex>{{'PRODUCTITEM.E015_ALWAYS_AVAILABLE' | translate}}</mat-slide-toggle>

            <!--  ************************************  -->
            <!--              PRODUCTITEM IS-E015            -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="e015FromSustainableEnergy" [(ngModel)]="data.productItem.e015Attributes.isFromSustainableEnergy" fxFlex>{{'PRODUCTITEM.E015_FROM_SUSTAINABLE_ENERGY' | translate}}</mat-slide-toggle>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="putProductItem.invalid? true : false"
          (click)="saveCustomerProductItem()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
